//bootstrap for laravel
require('./bootstrap');

//Bootstrap 5.0
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

//theme js
require('../js/theme/src/theme')

//laravel tel
import intlTelInput from 'intl-tel-input';

window.intlTelInput = intlTelInput;
//Add your custom code here